import _jsx from "@babel/runtime/helpers/jsx";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
var _class;
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import React from 'react';
// import PropTypes from 'prop-types';
// import _ from 'lodash';
// import moment from 'moment';
import { injectIntl, FormattedMessage } from 'react-intl';
// import ExpansionPanel from '@mui/material/ExpansionPanel';
import Typography from '@mui/material/Typography';
// import ExpansionPanelSummary from '@mui/material/ExpansionPanelSummary';
// import ExpansionPanelDetails from '@mui/material/ExpansionPanelDetails';
// import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

import messages from './messages';
import intlPropTypes from '../../../constants/intlPropTypes';

// const userShape = PropTypes.shape({
//   _id: PropTypes.string.isRequired,
//   firstName: PropTypes.string.isRequired,
//   lastName: PropTypes.string.isRequired,
// }).isRequired;
//
// const lessonShape = PropTypes.shape({
//   name: PropTypes.string.isRequired,
// }).isRequired;
var ConfirmDeleteDescription = injectIntl(_class = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(ConfirmDeleteDescription, _React$PureComponent);
  var _super = _createSuper(ConfirmDeleteDescription);
  function ConfirmDeleteDescription() {
    _classCallCheck(this, ConfirmDeleteDescription);
    return _super.apply(this, arguments);
  }
  _createClass(ConfirmDeleteDescription, [{
    key: "render",
    value: function render() {
      // const { courseRelations } = this.props;

      // const favoriteCourses = _.get(courseRelations, 'favoriteCourses', []);
      // const discussions = _.get(courseRelations, 'discussions', []);
      // const userCourses = _.get(courseRelations, 'userCourses', []);
      // const videoNotes = _.get(courseRelations, 'videoNotes', []);
      // const textNotes = _.get(courseRelations, 'textNotes', []);
      // const tasks = _.get(courseRelations, 'tasks', []);

      return /*#__PURE__*/_jsx("div", {}, void 0, /*#__PURE__*/_jsx(Typography, {
        variant: "subtitle1",
        color: "secondary",
        paragraph: true
      }, void 0, /*#__PURE__*/React.createElement(FormattedMessage, messages.description)));
    }
  }]);
  return ConfirmDeleteDescription;
}(React.PureComponent)) || _class;
export { ConfirmDeleteDescription as default };